import type React from 'react'
import { useEffect } from 'react'

import { ProjectOrigin } from '@/types'
import { useCommit } from '../Modal/Import/hooks'

const PromoCrawler: React.FC = () => {
  const handleCommit = useCommit({
    teamId: undefined,
    folderId: undefined,
    projectOrigin: ProjectOrigin.CRAWLED,
    popupDownloadSitemapXml: true,
    // This route renders no UI of its own — bailing on the project limit would
    // leave a blank screen. Create a trial project and upsell on the project.
    fallbackToTrialOnLimit: true,
  })

  useEffect(() => {
    // @todo review
    // document.querySelector('body')?.classList.remove('--loaded')

    const data = localStorage.getItem('octopus-crawler-data')

    if (data) {
      const parse = JSON.parse(data)

      handleCommit(parse)

      localStorage.removeItem('octopus-crawler-data')
    }
  }, [])

  return null
}

export default PromoCrawler
